import { render } from "./EventBody.vue?vue&type=template&id=74ba9799&scoped=true"
import script from "./EventBody.vue?vue&type=script&lang=js"
export * from "./EventBody.vue?vue&type=script&lang=js"

import "./EventBody.vue?vue&type=style&index=0&id=74ba9799&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74ba9799"]])

export default __exports__